import PropTypes from 'prop-types'
import ArrowDownIcon from '@heroicons/react/24/solid/ArrowDownIcon'
import ArrowUpIcon from '@heroicons/react/24/solid/ArrowUpIcon'
import { Avatar, Card, CardContent, Skeleton, Stack, SvgIcon, Typography } from '@mui/material'

/**
 * 前期間比（%）。前期間が 0 のときは割合を出せないため null を返す
 * （0 → 5 を「+500%」等と表示すると実態より大きく見えるため、差分表示に切り替える）
 */
const calcDifference = (value, previous) => {
  if (previous === 0) return null
  return Math.round(((value - previous) / previous) * 100)
}

export const PatternKpiCard = (props) => {
  // showComparison=false のときは前期間比を出さない（合計値カードなど比較対象がない用途向け）
  const { color = 'primary.main', icon, label, loading = false, previous = 0, value, formatValue, showComparison = true } = props

  const difference = calcDifference(value, previous)
  // 増減が無いときは中立扱い（同値で「↑ 0%」と増加色を出さない）
  const positive = value > previous

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack alignItems="flex-start" direction="row" justifyContent="space-between" spacing={3}>
          <Stack spacing={1}>
            <Typography color="text.secondary" variant="overline">
              {label}
            </Typography>
            {loading ? (
              <Skeleton width={90} height={40} />
            ) : (
              <Typography variant="h4">{formatValue ? formatValue(value) : value.toLocaleString()}</Typography>
            )}
          </Stack>
          <Avatar sx={{ backgroundColor: color, height: 56, width: 56 }}>
            <SvgIcon>{icon}</SvgIcon>
          </Avatar>
        </Stack>

        {!loading && showComparison && (
          <Stack alignItems="center" direction="row" spacing={2} sx={{ mt: 2 }}>
            {difference === null ? (
              <Typography color="text.secondary" variant="body2">
                {previous === 0 && value === 0 ? '前期間も実績なし' : '前期間は実績なし'}
              </Typography>
            ) : difference === 0 ? (
              <Typography color="text.secondary" variant="body2">
                前期間と同じ
              </Typography>
            ) : (
              <Stack alignItems="center" direction="row" spacing={0.5}>
                <SvgIcon color={positive ? 'success' : 'error'} fontSize="small">
                  {positive ? <ArrowUpIcon /> : <ArrowDownIcon />}
                </SvgIcon>
                <Typography color={positive ? 'success.main' : 'error.main'} variant="body2">
                  {Math.abs(difference)}%
                </Typography>
              </Stack>
            )}
            <Typography color="text.secondary" variant="caption">
              前の同じ期間と比較
            </Typography>
          </Stack>
        )}
      </CardContent>
    </Card>
  )
}

PatternKpiCard.propTypes = {
  color: PropTypes.string,
  formatValue: PropTypes.func,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  previous: PropTypes.number,
  showComparison: PropTypes.bool,
  value: PropTypes.number,
}
